import cookie from "react-cookies";

const CookieService = (function () {
  let _service;

  const ACCESS_TOKEN = "accessToken";
  const REFRESH_TOKEN = "refreshToken";
  const REMEMBER_ME = "rememberMe";

  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }

  function _options(expires) {
    return {path: "/", expires};
  }

  function _setAppToken(tokenObj, rememberMe = false) {
    cookie.save(ACCESS_TOKEN, tokenObj.access, _options());
    cookie.save(REMEMBER_ME, rememberMe, _options());
    if (tokenObj.refresh && rememberMe === true) {
      const expires = new Date();
      expires.setDate(Date.now() + 1000 * 60 * 60 * 6);
      cookie.save(REFRESH_TOKEN, tokenObj.refresh, _options(expires));
    }
  }

  function _getAccessToken() {
    return cookie.load(ACCESS_TOKEN, _options());
  }

  function _getRefreshToken() {
    if (_getRememberMe() === "true") {
      return cookie.load(REFRESH_TOKEN, _options());
    }
    return null;
  }

  function _getRememberMe() {
    return cookie.load(REMEMBER_ME, _options());
  }

  function _clearToken() {
    cookie.remove(ACCESS_TOKEN, _options());
    cookie.remove(REFRESH_TOKEN, _options());
    cookie.remove(REMEMBER_ME, _options());
  }

  function _isTokenAvailable() {
    if (_getRememberMe() === "true") {
      return _getAccessToken() !== undefined || _getRefreshToken() !== undefined;
    }

    return _getAccessToken() !== undefined;
  }

  return {
    getService: _getService,
    setToken: _setAppToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    getRememberMe: _getRememberMe,
    clearToken: _clearToken,
    isTokenAvailable: _isTokenAvailable,
  };
})();

export default CookieService;
